import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'privacy-policy-v20210223',
  templateUrl: './privacy-policy-v20210223.component.html',
  styleUrls: ['./privacy-policy-v20210223.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrivacyPolicyV20210223Component implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
